import Tidal from '../../pages-dynamic/info/tidal/privacy';
import BotMart from '../../pages-dynamic/info/botmart/privacy';

export default process.env.WHITE_LABEL_ORG === 'botmart' ? BotMart : Tidal;
